import React from "react";

import { css, cx } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { PractitionerBillingTable } from "@/uiKit/molecules/PractitionerBillingTable/PractitionerBillingTable.tsx";

export type PractitionerBillingCardProps = {
  className?: string;
};

export const PractitionerBillingCard: React.FC<PractitionerBillingCardProps> = ({ className }) => {
  const styles = useStyles(makeStyles);

  return (
    <Card className={cx(styles.container, className)}>
      <CardContent>
        <PractitionerBillingTable />
      </CardContent>
    </Card>
  );
};

const makeStyles = () => ({
  container: css({}),
});
